import { Autocomplete, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, TextField } from "@mui/material";
import CascateList from "../../../../../../common/components/cascate_list";
import PrimaryButton from "../../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import { DefaultFuncioanrio } from "../../../../../../common/components/default_funcionarios.select";
import { DefaultFornecedor } from "../../../../../../common/components/default_fornecedor_select";
import { DefaultCliente } from "../../../../../../common/components/default_client_select";
import { DefaultDateRangePickerInput } from "../../../../../../common/components/default_date_range_picker_input";

type Props = {
  ResponsavelPesquisa: number;
  FornecedorPesquisa: number;
  ClientePesquisa: number;
  centroDeCustoLista: { id: number; title: string }[];
  centroDeCusto: number[];
  tipoTempo: number;
  tipoStatus: number;
  tipoDiaPraticavel: number;
  dataReceberDe: Date | null;
  dataReceberAte: Date | null;
  handleCentroDeCusto: (v: number[]) => void;
  onClearFilters: () => void;
  handleResponsavelChange: (v: number) => void;
  handleFornecedorChange: (v: number) => void;
  handleClienteChange: (v: number) => void;
  handleTipoTempo: (v: number) => void,
  handleTipoStatus: (v: number) => void,
  handleTipoDiaPraticavel: (v: number) => void,
  handleDataReceberRangeChange: (v: Date | null, x: Date | null) => void;
};

export const Header = ({
  ResponsavelPesquisa,
  FornecedorPesquisa,
  ClientePesquisa,
  tipoTempo,
  tipoDiaPraticavel,
  centroDeCusto,
  centroDeCustoLista,
  dataReceberAte,
  dataReceberDe,
  tipoStatus,
  handleTipoStatus,
  onClearFilters,
  handleResponsavelChange,
  handleCentroDeCusto,
  handleFornecedorChange,
  handleClienteChange,
  handleTipoTempo,
  handleTipoDiaPraticavel,
  handleDataReceberRangeChange
}: Props) => {

  return (
    <CascateList title="Filtros" defaultOpen>
      <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 items-end">
        
        {/* Responsável */}
        <div className="w-full">
          <DefaultFuncioanrio
            key={`resp-${ResponsavelPesquisa}`}
            name="ResponsavelPesquisar"
            value={ResponsavelPesquisa || null}
            onChange={(valor) => handleResponsavelChange(Number(valor))}
            label="Responsável"
          />
        </div>

        {/* Centro de Custo */}
        <FormControl size="small" fullWidth>
          <Autocomplete
            size="small"
            multiple
            options={centroDeCustoLista}
            value={centroDeCustoLista.filter((i) => centroDeCusto.includes(i.id))}
            getOptionLabel={(i) => i.title}
            onChange={(_, newValue) => {
              handleCentroDeCusto(newValue.map((i) => i.id));
            }}
            isOptionEqualToValue={(opt, val) => opt.id === val.id}
            renderInput={(params) => (
              <TextField {...params} size="small" label="Centro de custo" />
            )}
          />
        </FormControl>

        {/* Fornecedor */}
        <div className="w-full">
          <DefaultFornecedor
            key={`forn-${FornecedorPesquisa}`}
            name="PesquisarFornecedor"
            value={FornecedorPesquisa || null}
            onChange={(valor) => handleFornecedorChange(Number(valor))}
            label="Fornecedor"
          />
        </div>

        {/* Cliente */}
        <div className="w-full">
          <DefaultCliente
            key={`cli-${ClientePesquisa}`}
            name="PesquisarCliente"
            value={ClientePesquisa || null}
            onChange={(valor) => handleClienteChange(Number(valor))}
            label="Cliente"
          />
        </div>

        {/* Condição do Tempo */}
        <FormControl size="small" fullWidth>
          <InputLabel id="select-tempo-label" size="small">Condição do Tempo</InputLabel>
          <Select
            size="small"
            labelId="select-tempo-label"
            label="Condição do Tempo"
            value={tipoTempo}
            onChange={(event: SelectChangeEvent<number>) => {
              handleTipoTempo(event.target.value as number)
            }}
          >
            <MenuItem value={0}>Todos</MenuItem>
            <MenuItem value={1}>Bom</MenuItem>
            <MenuItem value={2}>Nublado</MenuItem>
            <MenuItem value={3}>Chuvoso</MenuItem>
          </Select>
        </FormControl>

        {/* Status */}
        <FormControl size="small" fullWidth>
          <InputLabel id="select-status-label" size="small">Status</InputLabel>
          <Select
            size="small"
            labelId="select-status-label"
            label="Status"
            value={tipoStatus}
            onChange={(event: SelectChangeEvent<number>) => {
              handleTipoStatus(event.target.value as number)
            }}
          >
            <MenuItem value={3}>Todos</MenuItem>
            <MenuItem value={0}>Em elaboração</MenuItem>
            <MenuItem value={2}>Liberado para aprovação</MenuItem>
            <MenuItem value={1}>Aprovado</MenuItem>
          </Select>
        </FormControl>

        {/* Dia Praticável */}
        <FormControl size="small" fullWidth>
          <InputLabel id="select-dia-praticavel-label" size="small">Dia Praticável</InputLabel>
          <Select
            size="small"
            labelId="select-dia-praticavel-label"
            label="Dia Praticável"
            value={tipoDiaPraticavel}
            onChange={(event: SelectChangeEvent<number>) => {
              handleTipoDiaPraticavel(event.target.value as number)
            }}
          >
            <MenuItem value={0}>Todos</MenuItem>
            <MenuItem value={1}>Sim</MenuItem>
            <MenuItem value={2}>Não</MenuItem>
            <MenuItem value={3}>Parcial</MenuItem>
          </Select>
        </FormControl>

        <div className="w-full md:col-span-2">
          <DefaultDateRangePickerInput
            label='Data de'
            dataDe={dataReceberDe ?? null}
            dataAte={dataReceberAte ?? null}
            onChange={async (start, end) => {
              handleDataReceberRangeChange(start, end)
            }}
          />
        </div>
        <div className="flex justify-end col-span-1 md:col-span-2 lg:col-span-3 xl:col-span-4 mt-2">
          <div className="w-full md:w-[180px]">
            <PrimaryButton
              startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
              buttonColor="yellow"
              onClick={onClearFilters}
            >
              Limpar filtros
            </PrimaryButton>
          </div>
        </div>
        
      </div>
    </CascateList>
  );
};